import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import { Card, Form, Space, Row, Col, Input, Divider, Select } from "antd";
import TechBaseButton from "DisplayCoreV2/Button";
import TechBaseFilePond from "DisplayCoreV2/FilePond";
import TechBaseText from "DisplayCoreV2/Text";
import { requireRule } from "utils/rules";

const PaymentFields = [
  { title: <TechBaseText content="{{PO_REF_NO}}" />, name: "salesID" },
  { title: <TechBaseText content="{{INTRODUCER_ID}}" />, name: "introducerDetail" },
  { title: <TechBaseText content="{{REMARKS}}" />, name: "remarks" },
];

const Step3 = (props) => {
  const { selectedSlot, selectedItem, onNext, onBack, formData, paymentOptions, salesType } = props;
  const [form] = Form.useForm();
  const [summaryValue, setSummaryValue] = useState({});
  const isSubmittingRef = useRef(false); // Prevent multiple submissions
  const [isSubmitting, setIsSubmitting] = useState(false); // UI disable button

  useEffect(() => {
    let tmp = {};
    tmp.lotPayment = (formData.step2?.lot?.downpayment || 0) - (formData.step2?.booking_fee_received || 0);
    tmp.urnPayment = _.sumBy(selectedItem, (val) => val.quantity * val.Price);
    tmp.final = tmp.lotPayment + tmp.urnPayment;
    setSummaryValue(tmp);
  }, [formData, selectedItem]);

  useEffect(() => {
    if (!_.isEmpty(props.bookingOrder)) {
      form.setFieldsValue({ salesID: props.bookingOrder?.SalesId || "" });
    }
  }, [props.bookingOrder]);

  useEffect(() => {
    _.map(PaymentFields, (field) => {
      if (props.disabledPORefNo && field.name === "salesID") {
        field.disabled = true;
      } else {
        delete field.disabled;
      }
    });
  }, [props.disabledPORefNo]);

  useEffect(() => {
    if (paymentOptions && paymentOptions.length > 0) {
      const filteredOptions = _.filter(
        paymentOptions,
        (opt) => opt.Sort === 0 && !opt.ParameterName.toLowerCase().includes("wallet")
      );
      if (filteredOptions.length) {
        form.setFieldValue("paymentType", filteredOptions[0].ParameterValue);
      }
    }
  }, [paymentOptions]);

  const Summary = [
    { title: <TechBaseText content="{{SELECTED_MONUMENT}}" />, value: selectedSlot.ProductName },
    {
      title: <TechBaseText content="{{FINAL_PAYMENT}} (RM)" />,
      value: summaryValue.final?.toFixed(2),
      bold: true,
    },
  ];

  return (
    <Form
      onFinish={(value) => {
        if (isSubmittingRef.current) {
          console.warn("🚨 Form submission prevented: Already submitting!");
          return;
        }

        isSubmittingRef.current = true;
        console.log("✅ Form Submitted:", value);

        onNext(value);
      }}
      layout="vertical"
      form={form}
      initialValues={{
        purchaser_type: "existing",
        nationality: 127,
        mobile_prefix: "60",
        mobile_prefix_2: "60",
        identity_type: "ic",
        gender: "male",
        country: 127,
        state: 9,
        mailing_country: 127,
        mailing_state: 9,
        ...formData.step3,
      }}
    >
      <Space direction="vertical" className="w-100">
        <Card>
          <div className="lead">
            <TechBaseText content="{{SELECTED_MONUMENT}}." />: {selectedSlot.ProductName}
          </div>
        </Card>
        <Card>
          <div className="lead">
            <TechBaseText content="{{PURCHASE_SUMMARY}}" />
          </div>
          {Summary.map((field) => (
            <React.Fragment key={field.title}>
              <Divider className="my-3" />
              <Row gutter={32}>
                <Col xs={24} md={12}>
                  {field.bold ? <strong>{field.title}</strong> : field.title}
                </Col>
                <Col xs={24} md={12}>{field.value}</Col>
              </Row>
            </React.Fragment>
          ))}
        </Card>
        <Card>
          <div className="lead">
            <TechBaseText content="{{PAYMENT}}" />
          </div>
          <Divider className="my-3" />
          <Row gutter={32}>
            <Col xs={24} md={12}>
              <Form.Item className="m-0" name="paymentType" label="Payment Type" rules={[requireRule]}>
                <Select
                  size="large"
                  options={_.filter(paymentOptions, (opt) => opt.Sort === 0 && !opt.ParameterName.toLowerCase().includes("wallet"))}
                  fieldNames={{ label: "ParameterName", value: "ParameterValue" }}
                />
              </Form.Item>
            </Col>
            {PaymentFields.map((field) => (
              <Col xs={24} md={12} key={field.name}>
                <Form.Item className="m-0" name={field.name} label={field.title}>
                  <Input size="large" disabled={field.disabled} />
                </Form.Item>
              </Col>
            ))}

            <Divider className="my-3" />
            <Col xs={24} md={12}>
              <Form.Item name="receipt" label={<TechBaseText content="{{PROOF_OF_PAYMENT}}" />}>
                <TechBaseFilePond acceptedFileTypes={["image/*"]} />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <Space className="d-flex justify-content-end" align="center">
          <TechBaseButton onClick={() => onBack(form.getFieldsValue())} disabled={isSubmitting}>
            <TechBaseText content="{{BACK}}" />
          </TechBaseButton>
          <TechBaseButton htmlType="submit" color="primary">
            <TechBaseText content="{{SUBMIT}}" />
          </TechBaseButton>
        </Space>
      </Space>
    </Form>
  );
};

export default Step3;